import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const putChangeVisualValidationComparisonData = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  dataObjectVersion1Id: number;
  dataObjectVersion2Id: number;
}) =>
  apiClient
    .put<{
      externalCode: string;
    }>(
      expand(ValidationDashboardUrl.COMPARISON_CHANGE_DATA, { externalCode }),
      data,
    )
    .then((response) => response.data);

export const useChangeVisualValidationComparisonDataMutation =
  createApiMutationHook(
    ['changeVisualValidationComparisonData'],
    putChangeVisualValidationComparisonData,
  );
